// Pro-light icons Crema used before adopting Funeral Manager's icon set.
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFunnelDollar,
  faAlarmExclamation,
  faAnalytics,
  faArrowRight,
  faArrowAltFromLeft,
  faArrowSquareDown,
  faBadgeDollar,
  faBolt,
  faBold,
  faArchive,
  faBookOpen,
  faCalculator,
  faCalendarAlt,
  faCalendarDay,
  faCalendarMinus,
  faCheck,
  faList,
  faCheckCircle,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleNotch,
  faClock,
  faCogs,
  faCompressAlt,
  faCopy,
  faCreditCard,
  faDatabase,
  faDigging,
  faEdit,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileAlt,
  faFileCsv,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faFilePlus,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faFont,
  faHotel,
  faFileImage,
  faFileExcel,
  faFilePowerpoint,
  faFileWord,
  faIndent,
  faItalic,
  faLandmark,
  faListUl,
  faListOl,
  faLongArrowLeft,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMinus,
  faMoneyCheckAlt,
  faMoon,
  faPaperclip,
  faPaperPlane,
  faParagraph,
  faPen,
  faPercent,
  faPhoneAlt,
  faPiggyBank,
  faPlus,
  faPrint,
  faQuestionCircle,
  faQuoteLeft,
  faRedo,
  faQuestionSquare,
  faSearch,
  faCheckSquare,
  faSignOut,
  faSlidersH,
  faSort,
  faSortDown,
  faSortUp,
  faSpinnerThird,
  faSun,
  faStrikethrough,
  faSwatchbook,
  faSync,
  faSyncAlt,
  faTasks,
  faTicket,
  faTimes,
  faUndo,
  faUndoAlt,
  faUnlock,
  faUser,
  faUsers,
  faExclamation,
  faInfoSquare,
  faEnvelope,
  faBell,
  faBellOn,
  faLockOpen,
  faLock,
  faPersonDolly,
  faQuestion,
  faSortAlt,
  faLightbulbExclamation
} from '@fortawesome/pro-light-svg-icons'

library.add(
  faAlarmExclamation,
  faAnalytics,
  faArrowRight,
  faArrowAltFromLeft,
  faArrowSquareDown,
  faArchive,
  faBadgeDollar,
  faBell,
  faBolt,
  faBold,
  faBookOpen,
  faCalculator,
  faCalendarAlt,
  faCalendarDay,
  faCalendarMinus,
  faCheck,
  faList,
  faCheckCircle,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleNotch,
  faClock,
  faCogs,
  faCompressAlt,
  faCopy,
  faCreditCard,
  faDatabase,
  faDigging,
  faEdit,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileAlt,
  faFileCsv,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faFilePlus,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faHotel,
  faFileImage,
  faFileExcel,
  faFileWord,
  faFilePowerpoint,
  faFont,
  faFunnelDollar,
  faIndent,
  faItalic,
  faLandmark,
  faListUl,
  faListOl,
  faLongArrowLeft,
  faLightbulbExclamation,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMinus,
  faMoneyCheckAlt,
  faMoon,
  faPaperclip,
  faPaperPlane,
  faParagraph,
  faPen,
  faPercent,
  faPhoneAlt,
  faPiggyBank,
  faPlus,
  faPrint,
  faQuestionCircle,
  faQuoteLeft,
  faRedo,
  faQuestionSquare,
  faSearch,
  faSignOut,
  faSlidersH,
  faCheckSquare,
  faSort,
  faSortDown,
  faSortUp,
  faSpinnerThird,
  faStrikethrough,
  faSun,
  faSwatchbook,
  faSync,
  faSyncAlt,
  faTasks,
  faTicket,
  faTimes,
  faUndo,
  faUndoAlt,
  faUnlock,
  faUser,
  faUsers,
  faExclamation,
  faUsers,
  faBold,
  faItalic,
  faStrikethrough,
  faFont,
  faParagraph,
  faListOl,
  faInfoSquare,
  faEnvelope,
  faBellOn,
  faLockOpen,
  faLock,
  faPersonDolly,
  faQuestion,
  faSortAlt
)

// Solid icons of the work ("dossier") menu, as Funeral Manager's dossier menu.
import {
  faUser as faUserSolid,
  faDatabase as faDatabaseSolid,
  faClock as faClockSolid,
  faTasks as faTasksSolid,
  faFile as faFileSolid,
  faPaperclip as faPaperclipSolid,
  faEuroSign as faEuroSignSolid,
  faFileAlt as faFileAltSolid
} from '@fortawesome/pro-solid-svg-icons'

library.add(
  faUserSolid,
  faDatabaseSolid,
  faClockSolid,
  faTasksSolid,
  faFileSolid,
  faPaperclipSolid,
  faEuroSignSolid,
  faFileAltSolid
)
